import { render, staticRenderFns } from "./RechnungsTable.vue?vue&type=template&id=48335d96&scoped=true"
import script from "./RechnungsTable.vue?vue&type=script&lang=js"
export * from "./RechnungsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48335d96",
  null
  
)

export default component.exports